var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[`${_vm.fontClass}`, `button-${_vm.variant || 'primary'}-local`, `button-${_vm.size}-local`, { 'pill-button': _vm.pill, 'w-100': _vm.block, 'button-secondary-padding': _vm.secondaryPadding}],style:({
    '--disabled-link-color': `var(${_vm.disabledLinkColor});`,
    'max-width': `${_vm.buttonWidthFit ? 'fit-content' : 'unset'}`
  }),attrs:{"disabled":_vm.isLoading || _vm.isDisabled},on:{"click":function($event){$event.stopPropagation();return _vm.onClick()}}},[_vm._t("default"),_vm._v(" "),(_vm.isLoading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }